import React, { ReactNode } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { twMerge } from "tailwind-merge";
import { FreeMode } from "swiper/modules";
import SwipeCardLoadMore from "@components/common/SwipeCardLoadMore";
import { useRouter } from "next/router";

interface SwipeCardsProps {
  items: ReactNode[];
  slidesPerView?: number;
  className?: string;
  hasNextPage?: boolean;
  onLoadMore?: () => void;
  isLoading?: boolean;
  skeletonType?: "tour" | "post";
}

const SwipeCards: React.FC<SwipeCardsProps> = ({
  items,
  slidesPerView = 1.2,
  className = "",
  hasNextPage = false,
  onLoadMore,
  isLoading = false,
  skeletonType,
}) => {
  const mergedClasses = twMerge("swiper-container", className);
  const router = useRouter();
  const loadMoreCard = hasNextPage && (
    <SwiperSlide
      style={{
        //this ensures responsive width on mobile ==> Fix for Swiper library issue: initially loads with PC width causing CLS;
        width: 100 / slidesPerView - 12 / slidesPerView + `vw`,
        marginRight: "16px",
        height: "auto",
      }}
    >
      <div className="flex h-full">
        <SwipeCardLoadMore
          isLoading={isLoading}
          onClick={onLoadMore}
          skeletonType={skeletonType}
        />
      </div>
    </SwiperSlide>
  );

  return (
    <div className="flex flex-row md:hidden -ml-8">
      <Swiper
        key={router.asPath}
        spaceBetween={16}
        slidesPerView={"auto"} // cards visible + peek
        className={mergedClasses}
        freeMode={{
          enabled: true,
          sticky: true,
          momentumBounce: false,
        }}
        resistanceRatio={0}
        slidesOffsetBefore={0}
        slidesOffsetAfter={0}
        modules={[FreeMode]}
        style={{ height: "auto", paddingRight: 16, paddingLeft: 32 }}
      >
        {items.map((item, index) => (
          <SwiperSlide
            key={index}
            style={{
              //Fix for Swiper library issue: swiper library fix render issue in first render
              width: 100 / slidesPerView - 12 / slidesPerView + `vw`,
              marginRight: "16px",
              paddingBottom: "16px",
            }}
          >
            {item}
          </SwiperSlide>
        ))}
        {loadMoreCard}
      </Swiper>
    </div>
  );
};

export default SwipeCards;
